import { Stack } from '@fukuri-admins/ui/common';
import styles from './emptyStyles.module.scss';

/**
 * 利用者一覧（BankAccount）Empty 状態 Presentation
 *
 * 利用者が 0 件のときに表示する
 */
export const UserListBankAccountEmptyPresentation: React.FC = () => (
  <div className={styles.root} data-testid='user-list-bank-account-empty'>
    <Stack direction='column' gap={8} alignItems='center' justifyContent='center'>
      <p className={styles.message}>利用者が登録されていません</p>
    </Stack>
  </div>
);
